import { Spinner } from "react-bootstrap";

const MySpinner = () => {
    return <div className="py-3 text-center">
        <Spinner animation="grow" className="spinner-pink" />
    </div>;
}

export default MySpinner;
